import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useTemplatePlaceholderRow } from '../../../../hooks/useTemplatePlaceholderRow';
import { TemplatePlaceholderRowProps } from './types';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import { InputLabel, TextField } from '@mui/material';
import BrushIcon from '../../../../../../../assets/svg/brush.svg?react';
import { ProgressOverlay } from '../../../../../../common/progress-overlay/ProgressOverlay';
import Checkbox from '@mui/material/Checkbox';
import { useAppSelector } from '../../../../../../common/hooks/useAppSelector';
import { selectTemplatePlaceholdersIndexes } from '../../../../../../slices/templatePlaceholdersIndexes/templatePlaceholdersIndexes';
import { v4 as uuidv4 } from 'uuid';

const TemplatePlaceholderRow = ({
  data,
  id,
  index,
  documentHTMLId,
  placeholderCheckUncheck,
}: TemplatePlaceholderRowProps) => {
  const { t } = useTranslation();
  const {
    field,
    setField,
    setPlaceholder,
    placeholder,
    placeholderIdValue,
    value,
    setValue,
    editMode,
    handleSavePlaceholder,
    pendingStatus,
  } = useTemplatePlaceholderRow({ data, id, documentHTMLId });
  const chosenPlaceholdersIndexes = useAppSelector(selectTemplatePlaceholdersIndexes);
  const rowId = uuidv4();
  return (
    <tr>
      <td style={{ paddingBottom: '16px' }}>
        <TextField
          fullWidth
          label={t('labels.field')}
          variant='outlined'
          size='medium'
          value={field}
          slotProps={{
            input: { id: rowId + '-' + t('labels.field') },
            inputLabel: { shrink: true, htmlFor: rowId + '-' + t('labels.field') },
          }}
          onChange={(e) => setField(e.target.value)}
          disabled={Boolean(placeholderIdValue)}
        />
      </td>
      <td style={{ paddingBottom: '16px' }}>
        <TextField
          fullWidth
          label={t('labels.value')}
          variant='outlined'
          size='medium'
          slotProps={{
            input: { id: rowId + '-' + t('labels.value') },
            inputLabel: { shrink: true, htmlFor: rowId + '-' + t('labels.value') },
          }}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          disabled={Boolean(placeholderIdValue)}
        />
      </td>
      <td style={{ paddingBottom: '16px' }}>
        <TextField
          fullWidth
          label={t('labels.placeholder')}
          variant='outlined'
          size='medium'
          slotProps={{
            input: { id: rowId + '-' + t('labels.placeholder') },
            inputLabel: { shrink: true, htmlFor: rowId + '-' + t('labels.placeholder') },
          }}
          value={placeholder}
          onChange={(e) => setPlaceholder(e.target.value)}
          disabled={Boolean(placeholderIdValue) && !editMode}
        />
      </td>
      <td className='vertical-align-middle' style={{ paddingBottom: '16px' }}>
        <div className='d-flex align-items-center'>
          <Checkbox
            checked={chosenPlaceholdersIndexes?.includes(index)}
            onChange={(event) => {
              placeholderCheckUncheck(event, index, id);

              /*setChecked(event.target.checked);
              if (event.target.checked) {
                if (localStorage.getItem('templatePlaceholdersIndexes')) {
                  localStorage.setItem(
                    'templatePlaceholdersIndexes',
                    JSON.stringify([
                      ...JSON.parse(localStorage.getItem('templatePlaceholdersIndexes')),
                      index,
                    ])
                  );
                } else {
                  localStorage.setItem('templatePlaceholdersIndexes', JSON.stringify([index]));
                }
                if (localStorage.getItem('templatePlaceholdersIds')) {
                  localStorage.setItem(
                    'templatePlaceholdersIds',
                    JSON.stringify([
                      ...JSON.parse(localStorage.getItem('templatePlaceholdersIds')),
                      id,
                    ])
                  );
                } else {
                  localStorage.setItem('templatePlaceholdersIds', JSON.stringify([id]));
                }
              } else {
                localStorage.setItem(
                  'templatePlaceholdersIndexes',
                  JSON.stringify(
                    [...JSON.parse(localStorage.getItem('templatePlaceholdersIndexes'))].filter(
                      (el) => el !== index
                    )
                  )
                );
                localStorage.setItem(
                  'templatePlaceholdersIds',
                  JSON.stringify(
                    [...JSON.parse(localStorage.getItem('templatePlaceholdersIds'))].filter(
                      (el) => el !== id
                    )
                  )
                );
              }*/
            }}
            slotProps={{ input: { id: String(id) } }}
          />
          <InputLabel className='hidden-cropped' htmlFor={String(id)}>
            {data.value}
          </InputLabel>
          <Tooltip
            title={
              placeholderIdValue
                ? editMode
                  ? t('buttons.update')
                  : t('buttons.edit')
                : t('buttons.save')
            }
            placement='top'
            arrow
          >
            <IconButton className='table-row-icon-button' onClick={() => handleSavePlaceholder()}>
              {placeholderIdValue ? (
                editMode ? (
                  <CheckCircleOutlineOutlinedIcon
                    fontSize='small'
                    style={{ marginRight: 0, fill: '#152a58' }}
                  />
                ) : (
                  <BrushIcon />
                )
              ) : (
                <CheckCircleOutlineOutlinedIcon
                  fontSize='small'
                  style={{ marginRight: 0, fill: '#152a58' }}
                />
              )}
            </IconButton>
          </Tooltip>
          {pendingStatus && <ProgressOverlay />}
        </div>
      </td>
    </tr>
  );
};

export default memo(TemplatePlaceholderRow);
